import styles from './TableHeaderCell.module.scss';

export interface TableHeaderCellProps {
  /** Header title text */
  title: string;
  /** Additional CSS classes */
  className?: string;
}

export const TableHeaderCell = ({ title, className = '' }: TableHeaderCellProps) => {
  return (
    <div className={`${styles.cell} ${className}`}>
      <span className={styles.title}>{title}</span>
    </div>
  );
};
